import { applyMiddleware, createStore, compose } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import logger from 'redux-logger';

import { reducers as rootReducer } from './redux';
import getPluginId from './helpers/getPluginId';

function ConfigureStore() {
  const rootPersistConfig = {
    key: `root-${getPluginId()}`,
    storage,
    whitelist: ['plugin', 'zone']
    // blacklist: ['secured', 'campaign', 'search', 'wwtk', 'calendar', 'alert']
  };

  /**
   * Persist reducer
   */
  const persistedReducer = persistReducer(rootPersistConfig, rootReducer);

  /**
   * Apply middlewares
   */
  const middlewares = [
    thunk
  ];

  if (process.env.NODE_ENV !== 'production') {
    middlewares.push(logger);
  }

  /**
   * Create store
   */
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const store = createStore(
    persistedReducer,
    composeEnhancers(applyMiddleware(
      ...middlewares
    ))
  );

  /**
   * Persistor to give it to PersistGate
   */
  const persistor = persistStore(store);

  return { store, persistor };
}

export default ConfigureStore();
